module.exports = __webpack_public_path__ + "img/pdf-file.9ba09874.jpg";